import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IntersemanalCenario } from 'types/Relatorios/Intersemanal';

export interface DataAnalisada {
  mes: number;
  ano: number;
  dia: number;
}

export interface RelatoriosIntersemanalState {
  mes: number;
  ano: number;
  dia: number;
  cenario: IntersemanalCenario;
}

const now = new Date();
const initialState: RelatoriosIntersemanalState = {
  mes: now.getMonth() + 1,
  ano: now.getFullYear(),
  dia: now.getDate(),
  cenario: 'preliminar',
};

const relatoriosIntersemanalSlice = createSlice({
  name: 'relatoriosIntersemanal',
  initialState,
  reducers: {
    setDataAnalisada: (state, action: PayloadAction<DataAnalisada>) => {
      state.mes = action.payload.mes;
      state.ano = action.payload.ano;
      state.dia = action.payload.dia;
    },
    setCenario: (state, action: PayloadAction<IntersemanalCenario>) => {
      state.cenario = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setDataAnalisada, setCenario, reset,
} = relatoriosIntersemanalSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fatiaIntersemanal = (state: any): RelatoriosIntersemanalState => state.relatoriosIntersemanal;
/**
 * Memorizado: devolve o mesmo objeto enquanto a data não muda. O `useSelector` compara por
 * referência, e um objeto novo a cada chamada desenharia de novo, a cada ação do Redux (RTK Query,
 * polling), toda tela que lê a data.
 */
export const selectIntersemanalDataAnalisada = createSelector(
  [
    (state: unknown) => fatiaIntersemanal(state).mes,
    (state: unknown) => fatiaIntersemanal(state).ano,
    (state: unknown) => fatiaIntersemanal(state).dia,
  ],
  (mes, ano, dia): DataAnalisada => ({ mes, ano, dia }),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectIntersemanalCenario = (state: any): IntersemanalCenario => (
  state.relatoriosIntersemanal.cenario
);

export default relatoriosIntersemanalSlice.reducer;
